export default __webpack_public_path__ + "static/media/send-receive.c2c6fc31.svg";